export const inputRange = {
    the: "Le",
    at: "à"
}